import React, { Component } from 'react';
import PropTypes from 'prop-types';
import v4 from 'uuid/v4';
import { connect } from 'react-redux';

import Form from '../Form';
import deferRender from '../../hocs/deferRender';
import makePendingActions from '../../redux/pending/actions';

const pendingActions = makePendingActions();

/**
 * PendingForm wraps a Form component and provides the desired pending data to
 * the provided onSubmit callback.
 *
 * @public
 * @author Connor Taylor
 */
export class PendingForm extends Component {
  onSubmit = (e) => {
    e.preventDefault();
    const { onSubmit, data } = this.props;

    if (onSubmit) {
      onSubmit(data);
    }
  };

  render() {
    const { data, createPendingData, id, ...rest } = this.props; // eslint-disable-line

    return (
      <Form {...rest} onSubmit={this.onSubmit}>
        {this.props.children}
      </Form>
    );
  }
}

PendingForm.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.any,
  id: PropTypes.string.isRequired,
  data: PropTypes.object,
};

PendingForm.defaultProps = {
  id: v4(),
};

const defer = deferRender({
  shouldRender: (props) => Boolean(props.data),
  onMount: (props) => props.createPendingData({ changes: {}, id: props.id }),
});

export default connect(
  (state, props) => {
    return {
      data: state.pending.data && state.pending.data[props.id],
    };
  },
  {
    createPendingData: pendingActions.createPendingData,
  },
)(defer(PendingForm));
